var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12C13.0384 12 14.0534 11.6921 14.9167 11.1152C15.7801 10.5383 16.453 9.7184 16.8504 8.75909C17.2477 7.79978 17.3517 6.74418 17.1491 5.72578C16.9466 4.70738 16.4465 3.77192 15.7123 3.03769C14.9781 2.30347 14.0426 1.80345 13.0242 1.60088C12.0058 1.39831 10.9502 1.50227 9.99091 1.89963C9.0316 2.29699 8.21166 2.9699 7.63478 3.83326C7.05791 4.69662 6.75 5.71165 6.75 6.75C6.75 8.14239 7.30312 9.47775 8.28769 10.4623C9.27226 11.4469 10.6076 12 12 12ZM12 13.5C8.74594 13.5 2.25 15.51 2.25 19.5V22.5H21.75V19.5C21.75 15.51 15.2541 13.5 12 13.5Z",
    fill: "#130D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.93b400a12599ae4e4ce295c9e8099a97.svg";
export { ForwardRef as ReactComponent };